enum DexfSettingsEnvironmentEnum {
	development = 'development',
	production = 'production'
}

export default DexfSettingsEnvironmentEnum;
